"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const S = (0, tslib_1.__importStar)(require("./styles"));
const Text = ({ size = '10px', color = 'black', family = 'ATTAleckSans', align = 'center', decoration = 'none', transform = 'none', font_style = 'normal', weight = '200', children, }) => {
    return ((0, jsx_runtime_1.jsx)(S.Container, Object.assign({ "data-testid": "text", color: color, size: size, family: family, align: align, decoration: decoration, transform: transform, font_style: font_style, weight: weight }, { children: children }), void 0));
};
exports.default = Text;
